import { render } from "./PlayerOne.vue?vue&type=template&id=f8c9f524&scoped=true"
import script from "./PlayerOne.vue?vue&type=script&lang=js"
export * from "./PlayerOne.vue?vue&type=script&lang=js"

import "./PlayerOne.vue?vue&type=style&index=0&id=f8c9f524&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c9f524"]])

export default __exports__